import { RuleCard } from 'shared/ui/rule-card/rule-card';
import { InfoCompletenessScoring } from 'store/api/apiTypes';

const titleMap = {
  company_name: [
    'entity_disambiguation',
    'contextual_association',
    'basic_consistency',
    'schema_readiness',
  ],
  business_address: [
    'address_completeness_accuracy',
    'contact_integration',
    'consistency_presentation',
    'schema_readiness',
  ],
  target_audience: [
    'presentation_quality',
    'consistency_across_pages',
    'specificity',
    'llm_citation_potential',
  ],
  geographic_focus: [
    'service_delivery_evidence',
    'specificity_for_ai_citation',
    'evidence_consistency',
    'schema_readiness',
  ],
  robots_txt_permissions: ['crawler_access'],
  llms_txt_configuration: ['file', 'structure', 'products_section'],
  structured_data: ['schema_exists', 'organization_schema', 'website_schema'],
  server_side_rendering: ['server_rendering'],
};

const _mockRule: InfoCompletenessScoring = {
  score: 0,
  reasoning: '',
  weight: 0,
  rule_applied: '',
  findings: undefined,
  what_is_missing: '',
  how_to_improve: '',
};

export type TitleMapKey = keyof typeof titleMap;

export interface ExpiredRulesProps {
  title: TitleMapKey;
}

export const ExpiredRules: React.FC<ExpiredRulesProps> = ({ title }) => {
  return (
    <>
      {titleMap[title]?.map(subTitle => (
        <RuleCard
          key={subTitle}
          title={subTitle}
          description=''
          variant='analysis'
          analysisScore={0}
          isTrialExpired
          onOpen={() => {}}
        />
      ))}
    </>
  );
};
